import script from "./CurrencyConflictPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyConflictPopup.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyConflictPopup.vue?vue&type=style&index=0&id=33deb1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33deb1f4"]])

export default __exports__